const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHexatech(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "891px",
    height: "358px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.955
    },
    fill: "#00b7e3",
    d: "M 152.5,-0.5 C 153.833,-0.5 155.167,-0.5 156.5,-0.5C 161.271,2.72562 166.271,5.72562 171.5,8.5C 172.499,24.4861 172.833,40.4861 172.5,56.5C 172.167,56.5 171.833,56.5 171.5,56.5C 162.847,51.6727 153.847,47.6727 144.5,44.5C 142.321,43.3228 139.987,42.3228 137.5,41.5C 137.167,41.5 136.833,41.5 136.5,41.5C 136.168,30.4798 136.501,19.4798 137.5,8.5C 142.729,5.72562 147.729,2.72562 152.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.557
    },
    fill: "#02acd8",
    d: "M 103.5,31.5 C 101.833,31.5 100.167,31.5 98.5,31.5C 99.8484,30.3994 101.348,29.3994 103,28.5C 103.483,29.448 103.649,30.448 103.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.962
    },
    fill: "#00b7e3",
    d: "M 264.5,135.5 C 248.128,114.128 229.128,95.4609 207.5,79.5C 207.158,78.6618 206.492,78.3284 205.5,78.5C 205.333,61.83 205.5,45.1633 206,28.5C 217.333,35.1667 228.667,41.8333 240,48.5C 240.333,67.1667 240.667,85.8333 241,104.5C 248.678,90.4667 256.845,76.8 265.5,63.5C 275.5,69.1667 285.5,74.8333 295.5,80.5C 296.521,81.0016 296.688,81.6683 296,82.5C 285.637,100.337 275.137,118.003 264.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.906
    },
    fill: "#2fb7dc",
    d: "M 98.5,31.5 C 100.167,31.5 101.833,31.5 103.5,31.5C 103.5,35.8333 103.5,40.1667 103.5,44.5C 102.883,44.6107 102.383,44.944 102,45.5C 98.6045,41.9349 95.1045,38.6015 91.5,35.5C 93.6626,33.9172 95.9959,32.5839 98.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#28b2d8",
    d: "M 91.5,35.5 C 95.1045,38.6015 98.6045,41.9349 102,45.5C 102.383,44.944 102.883,44.6107 103.5,44.5C 103.5,46.8333 103.5,49.1667 103.5,51.5C 100.397,49.5767 97.3968,47.41 94.5,45C 91.8823,42.8943 89.8823,40.3943 88.5,37.5C 89.2905,36.5987 90.2905,35.9321 91.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.967
    },
    fill: "#1ba8d1",
    d: "M 83.5,40.5 C 86.9378,43.4347 90.2711,46.6014 93.5,50C 97.0035,52.0222 100.337,54.1888 103.5,56.5C 103.5,59.1667 103.5,61.8333 103.5,64.5C 93.9527,58.6239 85.6194,51.2906 78.5,42.5C 80.0495,41.5592 81.7162,40.8925 83.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4dcceb",
    d: "M 137.5,41.5 C 139.987,42.3228 142.321,43.3228 144.5,44.5C 144.062,44.4346 143.728,44.6012 143.5,45C 152.053,54.3881 161.387,62.8881 171.5,70.5C 171.662,72.5273 171.495,74.5273 171,76.5C 170.147,74.8753 169.147,74.5419 168,75.5C 158.259,65.9202 148.092,56.9202 137.5,48.5C 137.5,46.1667 137.5,43.8333 137.5,41.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.983
    },
    fill: "#14a2cd",
    d: "M 78.5,42.5 C 85.6194,51.2906 93.9527,58.6239 103.5,64.5C 103.5,66.8333 103.5,69.1667 103.5,71.5C 93.8077,62.8047 84.141,54.1381 74.5,45.5C 75.795,44.5116 77.1283,43.5116 78.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#22add5",
    d: "M 88.5,37.5 C 89.8823,40.3943 91.8823,42.8943 94.5,45C 97.3968,47.41 100.397,49.5767 103.5,51.5C 103.5,53.1667 103.5,54.8333 103.5,56.5C 100.337,54.1888 97.0035,52.0222 93.5,50C 90.2711,46.6014 86.9378,43.4347 83.5,40.5C 84.6594,38.7497 86.326,37.7497 88.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#55cfec",
    d: "M 144.5,44.5 C 153.847,47.6727 162.847,51.6727 171.5,56.5C 171.5,61.1667 171.5,65.8333 171.5,70.5C 161.387,62.8881 152.053,54.3881 143.5,45C 143.728,44.6012 144.062,44.4346 144.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#0e9dc9",
    d: "M 74.5,45.5 C 84.141,54.1381 93.8077,62.8047 103.5,71.5C 103.5,73.8333 103.5,76.1667 103.5,78.5C 92.172,68.505 81.172,58.1717 70.5,47.5C 71.6049,46.3995 72.9382,45.7329 74.5,45.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#0897c4",
    d: "M 70.5,47.5 C 81.172,58.1717 92.172,68.505 103.5,78.5C 103.5,82.1667 103.5,85.8333 103.5,89.5C 90.5,76.8333 77.5,64.1667 64.5,51.5C 66.1184,49.684 68.1184,48.3507 70.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#47c8e8",
    d: "M 137.5,48.5 C 148.092,56.9202 158.259,65.9202 168,75.5C 169.147,74.5419 170.147,74.8753 171,76.5C 171.495,74.5273 171.662,72.5273 171.5,70.5C 171.5,65.8333 171.5,61.1667 171.5,56.5C 171.833,56.5 172.167,56.5 172.5,56.5C 172.5,63.8333 172.5,71.1667 172.5,78.5C 171.71,79.6085 171.21,80.9419 171,82.5C 160.57,72.0625 149.57,62.3958 138,53.5C 137.506,51.8659 137.34,50.1992 137.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.981
    },
    fill: "#0994c2",
    d: "M 64.5,51.5 C 77.5,64.1667 90.5,76.8333 103.5,89.5C 103.5,90.8333 103.5,92.1667 103.5,93.5C 89.5,80.1667 75.8333,66.5 62.5,52.5C 62.8417,51.6618 63.5084,51.3284 64.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#0991bf",
    d: "M 62.5,52.5 C 75.8333,66.5 89.5,80.1667 103.5,93.5C 103.5,97.1667 103.5,100.833 103.5,104.5C 87.1667,88.8333 71.1667,72.8333 55.5,56.5C 57.6626,54.9172 59.9959,53.5839 62.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#41c5e6",
    d: "M 136.5,41.5 C 136.833,41.5 137.167,41.5 137.5,41.5C 137.5,43.8333 137.5,46.1667 137.5,48.5C 137.34,50.1992 137.506,51.8659 138,53.5C 149.57,62.3958 160.57,72.0625 171,82.5C 171.21,80.9419 171.71,79.6085 172.5,78.5C 172.5,81.8333 172.5,85.1667 172.5,88.5C 172.167,88.5 171.833,88.5 171.5,88.5C 161.706,80.544 152.039,72.3774 142.5,64C 139.847,61.8663 137.847,59.3663 136.5,56.5C 136.5,51.5 136.5,46.5 136.5,41.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#0a8ebc",
    d: "M 55.5,56.5 C 71.1667,72.8333 87.1667,88.8333 103.5,104.5C 103.5,105.833 103.5,107.167 103.5,108.5C 86.5,91.8333 69.5,75.1667 52.5,58.5C 52.9731,57.0937 53.9731,56.427 55.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#0b8bb9",
    d: "M 52.5,58.5 C 69.5,75.1667 86.5,91.8333 103.5,108.5C 103.5,112.167 103.5,115.833 103.5,119.5C 84.1667,100.5 64.8333,81.5 45.5,62.5C 47.3356,60.412 49.6689,59.0787 52.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3bc1e3",
    d: "M 136.5,56.5 C 137.847,59.3663 139.847,61.8663 142.5,64C 152.039,72.3774 161.706,80.544 171.5,88.5C 171.785,90.288 171.452,91.9547 170.5,93.5C 159.135,83.4924 147.802,73.4924 136.5,63.5C 136.5,61.1667 136.5,58.8333 136.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#0c88b6",
    d: "M 45.5,62.5 C 64.8333,81.5 84.1667,100.5 103.5,119.5C 103.5,121.5 103.5,123.5 103.5,125.5C 91.8333,114.167 80.1667,102.833 68.5,91.5C 68.5,90.8333 68.1667,90.5 67.5,90.5C 59.1667,81.5 50.5,72.8333 41.5,64.5C 42.5137,63.3263 43.847,62.6596 45.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#0d85b3",
    d: "M 41.5,64.5 C 50.5,72.8333 59.1667,81.5 67.5,90.5C 65.8185,92.0075 63.8185,93.0075 61.5,93.5C 53.1667,84.8333 44.8333,76.1667 36.5,67.5C 37.9649,66.2632 39.6316,65.2632 41.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.959
    },
    fill: "#35bde1",
    d: "M 136.5,63.5 C 147.802,73.4924 159.135,83.4924 170.5,93.5C 171.452,91.9547 171.785,90.288 171.5,88.5C 171.833,88.5 172.167,88.5 172.5,88.5C 172.5,91.8333 172.5,95.1667 172.5,98.5C 171.778,98.9175 171.278,99.5842 171,100.5C 160,90.5 149,80.5 138,70.5C 137.79,68.9419 137.29,67.6085 136.5,66.5C 136.5,65.5 136.5,64.5 136.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#2eb9dd",
    d: "M 136.5,66.5 C 137.29,67.6085 137.79,68.9419 138,70.5C 149,80.5 160,90.5 171,100.5C 171.278,99.5842 171.778,98.9175 172.5,98.5C 172.5,99.8333 172.5,101.167 172.5,102.5C 171.842,103.398 171.176,104.398 170.5,105.5C 159.761,95.716 148.927,86.0494 138,76.5C 137.79,74.9419 137.29,73.6085 136.5,72.5C 136.5,70.5 136.5,68.5 136.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#0d81af",
    d: "M 36.5,67.5 C 44.8333,76.1667 53.1667,84.8333 61.5,93.5C 60.5637,94.9744 59.2303,95.9744 57.5,96.5C 49.1667,87.5 40.5,78.8333 31.5,70.5C 32.8993,69.1103 34.5659,68.1103 36.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#0e7eac",
    d: "M 31.5,70.5 C 40.5,78.8333 49.1667,87.5 57.5,96.5C 55.4832,97.5294 53.4832,98.5294 51.5,99.5C 42.5,91.1667 33.8333,82.5 25.5,73.5C 27.2163,71.9752 29.2163,70.9752 31.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.968
    },
    fill: "#0f7ba9",
    d: "M 25.5,73.5 C 33.8333,82.5 42.5,91.1667 51.5,99.5C 50.1007,100.89 48.4341,101.89 46.5,102.5C 38.1667,93.8333 29.8333,85.1667 21.5,76.5C 22.4363,75.0256 23.7697,74.0256 25.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.97
    },
    fill: "#1078a6",
    d: "M 21.5,76.5 C 29.8333,85.1667 38.1667,93.8333 46.5,102.5C 45.0351,103.737 43.3684,104.737 41.5,105.5C 33.1667,96.5 24.5,87.8333 15.5,79.5C 17.1815,77.9925 19.1815,76.9925 21.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#1d4e7d",
    d: "M 829.5,76.5 C 833.167,76.5 836.833,76.5 840.5,76.5C 840.333,88.5046 840.5,100.505 841,112.5C 850.428,102.738 861.261,100.905 873.5,107C 876.531,109.559 878.698,112.726 880,116.5C 881.454,132.429 881.954,148.429 881.5,164.5C 877.833,164.5 874.167,164.5 870.5,164.5C 870.866,150.459 870.366,136.459 869,122.5C 864.172,113.114 857.006,110.948 847.5,116C 844.894,117.938 843.061,120.438 842,123.5C 840.573,137.107 840.073,150.774 840.5,164.5C 836.833,164.5 833.167,164.5 829.5,164.5C 829.5,135.167 829.5,105.833 829.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#1175a3",
    d: "M 15.5,79.5 C 24.5,87.8333 33.1667,96.5 41.5,105.5C 40.4863,106.674 39.153,107.34 37.5,107.5C 28.5,99.1667 19.8333,90.5 11.5,81.5C 12.8333,80.8333 14.1667,80.1667 15.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.963
    },
    fill: "#22b0d7",
    d: "M 136.5,79.5 C 147.476,90.6398 158.976,101.306 171,111.5C 171.278,110.584 171.778,109.918 172.5,109.5C 172.5,111.833 172.5,114.167 172.5,116.5C 171.883,116.611 171.383,116.944 171,117.5C 168.408,114.238 165.241,111.738 161.5,110C 152.995,102.328 144.662,94.4948 136.5,86.5C 136.5,84.1667 136.5,81.8333 136.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.991
    },
    fill: "#1d4e7d",
    d: "M 408.5,80.5 C 412.167,80.5 415.833,80.5 419.5,80.5C 419.5,92.1667 419.5,103.833 419.5,115.5C 433.167,115.5 446.833,115.5 460.5,115.5C 460.5,103.833 460.5,92.1667 460.5,80.5C 464.167,80.5 467.833,80.5 471.5,80.5C 471.5,108.5 471.5,136.5 471.5,164.5C 467.833,164.5 464.167,164.5 460.5,164.5C 460.5,151.5 460.5,138.5 460.5,125.5C 446.833,125.5 433.167,125.5 419.5,125.5C 419.5,138.5 419.5,151.5 419.5,164.5C 415.833,164.5 412.167,164.5 408.5,164.5C 408.5,136.5 408.5,108.5 408.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#1172a0",
    d: "M 11.5,81.5 C 19.8333,90.5 28.5,99.1667 37.5,107.5C 35.31,108.374 34.31,110.041 34.5,112.5C 24.8333,103.5 15.5,94.1667 6.5,84.5C 8.00087,83.2485 9.66754,82.2485 11.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.941
    },
    fill: "#29b5db",
    d: "M 136.5,72.5 C 137.29,73.6085 137.79,74.9419 138,76.5C 148.927,86.0494 159.761,95.716 170.5,105.5C 171.176,104.398 171.842,103.398 172.5,102.5C 172.5,104.833 172.5,107.167 172.5,109.5C 171.778,109.918 171.278,110.584 171,111.5C 158.976,101.306 147.476,90.6398 136.5,79.5C 136.5,77.1667 136.5,74.8333 136.5,72.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "#126e9d",
    d: "M 6.5,84.5 C 15.5,94.1667 24.8333,103.5 34.5,112.5C 34.5,115.167 34.5,117.833 34.5,120.5C 23.1667,109.833 12.1667,98.8333 1.5,87.5C 3.00087,86.2485 4.66754,85.2485 6.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#61d2ed",
    d: "M 207.5,79.5 C 229.128,95.4609 248.128,114.128 264.5,135.5C 264.443,136.609 264.11,137.609 263.5,138.5C 261.801,138.66 260.134,138.494 258.5,138C 241.333,122.833 224.167,107.667 207,92.5C 206.186,87.9796 206.353,83.6463 207.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#1d4e7d",
    d: "M 682.5,86.5 C 684.453,92.0738 685.12,98.0738 684.5,104.5C 689.833,104.5 695.167,104.5 700.5,104.5C 700.5,107.5 700.5,110.5 700.5,113.5C 695.167,113.5 689.833,113.5 684.5,113.5C 684.059,126.241 684.559,138.908 686,151.5C 687.312,154.581 689.645,156.248 693,156.5C 695.041,155.577 697.208,155.244 699.5,155.5C 699.784,158.777 699.451,161.943 698.5,165C 693.167,165.667 687.833,165.667 682.5,165C 679.063,163.895 676.563,161.728 675,158.5C 673.549,143.572 673.049,128.572 673.5,113.5C 670.167,113.5 666.833,113.5 663.5,113.5C 663.5,110.5 663.5,107.5 663.5,104.5C 666.833,104.5 670.167,104.5 673.5,104.5C 673.173,99.456 673.506,94.456 674.5,89.5C 677.384,88.7908 680.051,87.7908 682.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#136b9a",
    d: "M 1.5,87.5 C 12.1667,98.8333 23.1667,109.833 34.5,120.5C 34.5,122.833 34.5,125.167 34.5,127.5C 22.8333,116.167 11.1667,104.833 -0.5,93.5C -0.5,91.8333 -0.5,90.1667 -0.5,88.5C 0.166667,88.1667 0.833333,87.8333 1.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#1babd3",
    d: "M 136.5,86.5 C 144.662,94.4948 152.995,102.328 161.5,110C 165.241,111.738 168.408,114.238 171,117.5C 171.383,116.944 171.883,116.611 172.5,116.5C 172.5,119.833 172.5,123.167 172.5,126.5C 168.709,123.882 165.043,121.049 161.5,118C 153.298,109.631 144.965,101.464 136.5,93.5C 136.5,91.1667 136.5,88.8333 136.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#0d85b3",
    d: "M 68.5,91.5 C 80.1667,102.833 91.8333,114.167 103.5,125.5C 103.5,128.5 103.5,131.5 103.5,134.5C 91.8333,123.167 80.1667,111.833 68.5,100.5C 68.5,97.5 68.5,94.5 68.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#58d0ec",
    d: "M 205.5,78.5 C 206.492,78.3284 207.158,78.6618 207.5,79.5C 206.353,83.6463 206.186,87.9796 207,92.5C 224.167,107.667 241.333,122.833 258.5,138C 260.134,138.494 261.801,138.66 263.5,138.5C 262.167,140.833 260.833,143.167 259.5,145.5C 258.078,145.291 256.745,144.791 255.5,144C 239.616,129.149 223.45,114.649 207,100.5C 206.814,97.9644 206.314,95.631 205.5,93.5C 205.5,88.5 205.5,83.5 205.5,78.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#146897",
    d: "M -0.5,93.5 C 11.1667,104.833 22.8333,116.167 34.5,127.5C 34.5,130.833 34.5,134.167 34.5,137.5C 22.8333,126.167 11.1667,114.833 -0.5,103.5C -0.5,100.167 -0.5,96.8333 -0.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.965
    },
    fill: "#15a6d0",
    d: "M 136.5,93.5 C 144.965,101.464 153.298,109.631 161.5,118C 165.043,121.049 168.709,123.882 172.5,126.5C 172.5,127.833 172.5,129.167 172.5,130.5C 160.5,120.5 148.5,110.5 136.5,100.5C 136.5,98.1667 136.5,95.8333 136.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#0d81af",
    d: "M 68.5,100.5 C 80.1667,111.833 91.8333,123.167 103.5,134.5C 103.5,136.833 103.5,139.167 103.5,141.5C 91.8333,130.167 80.1667,118.833 68.5,107.5C 68.5,105.167 68.5,102.833 68.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.957
    },
    fill: "#0fa1cd",
    d: "M 136.5,100.5 C 148.5,110.5 160.5,120.5 172.5,130.5C 172.5,132.833 172.5,135.167 172.5,137.5C 170.567,135.063 168.4,132.729 166,130.5C 165.667,130.833 165.333,131.167 165,131.5C 155.925,122.586 146.425,114.252 136.5,106.5C 136.5,104.5 136.5,102.5 136.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4ecdeb",
    d: "M 205.5,93.5 C 206.314,95.631 206.814,97.9644 207,100.5C 223.45,114.649 239.616,129.149 255.5,144C 256.745,144.791 258.078,145.291 259.5,145.5C 258.248,147.001 257.248,148.668 256.5,150.5C 254.745,149.928 253.078,149.094 251.5,148C 237.464,134.962 223.13,122.295 208.5,110C 207.033,107.622 206.033,105.122 205.5,102.5C 205.5,99.5 205.5,96.5 205.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#156494",
    d: "M -0.5,103.5 C 11.1667,114.833 22.8333,126.167 34.5,137.5C 34.5,140.167 34.5,142.833 34.5,145.5C 22.8333,134.167 11.1667,122.833 -0.5,111.5C -0.5,108.833 -0.5,106.167 -0.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.927
    },
    fill: "#1d4e7d",
    d: "M 506.5,103.5 C 530.426,101.426 541.426,112.426 539.5,136.5C 525.5,136.5 511.5,136.5 497.5,136.5C 498.03,150.031 505.03,156.697 518.5,156.5C 523.726,156.61 528.726,155.61 533.5,153.5C 535.026,155.751 536.026,158.251 536.5,161C 534.006,163.283 531.006,164.617 527.5,165C 497.164,168.997 483.664,155.83 487,125.5C 489.516,114.492 496.016,107.158 506.5,103.5 Z M 511.5,111.5 C 522.15,112.15 527.816,117.816 528.5,128.5C 518.145,128.832 507.812,128.499 497.5,127.5C 499.074,119.27 503.741,113.937 511.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.92
    },
    fill: "#1d4e7d",
    d: "M 620.5,103.5 C 626.509,103.334 632.509,103.501 638.5,104C 646.444,106.277 651.278,111.444 653,119.5C 653.27,134.517 653.77,149.517 654.5,164.5C 650.833,164.5 647.167,164.5 643.5,164.5C 643.799,162.396 643.466,160.396 642.5,158.5C 635.054,165.113 626.387,167.28 616.5,165C 605.58,159.126 602.413,150.293 607,138.5C 611.439,132.024 617.605,128.19 625.5,127C 630.78,125.905 636.113,125.405 641.5,125.5C 642.16,119.653 639.827,115.487 634.5,113C 626.738,111.659 619.404,112.826 612.5,116.5C 610.25,113.727 609.584,110.727 610.5,107.5C 613.865,105.941 617.198,104.608 620.5,103.5 Z M 638.5,133.5 C 639.833,133.5 641.167,133.5 642.5,133.5C 643.209,139.892 642.043,145.892 639,151.5C 634.426,156.15 628.926,157.65 622.5,156C 619.011,154.029 617.011,151.029 616.5,147C 617.109,142.446 619.442,139.113 623.5,137C 628.511,135.292 633.511,134.126 638.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.927
    },
    fill: "#1d4e7d",
    d: "M 726.5,103.5 C 750.426,101.426 761.426,112.426 759.5,136.5C 745.5,136.5 731.5,136.5 717.5,136.5C 718.03,150.031 725.03,156.697 738.5,156.5C 743.726,156.61 748.726,155.61 753.5,153.5C 755.026,155.751 756.026,158.251 756.5,161C 754.006,163.283 751.006,164.617 747.5,165C 717.164,168.997 703.664,155.83 707,125.5C 709.516,114.492 716.016,107.158 726.5,103.5 Z M 731.5,111.5 C 742.15,112.15 747.816,117.816 748.5,128.5C 738.145,128.832 727.812,128.499 717.5,127.5C 719.074,119.27 723.741,113.937 731.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.916
    },
    fill: "#1d4e7d",
    d: "M 792.5,103.5 C 800.961,103.05 809.294,103.716 817.5,105.5C 817.309,109.074 816.309,112.407 814.5,115.5C 805.547,111.137 796.88,111.637 788.5,117C 779.634,127.346 778.801,138.179 786,149.5C 794.388,156.984 803.721,158.317 814,153.5C 819.968,160.264 818.468,164.097 809.5,165C 777.833,167.997 765,153.83 771,122.5C 774.948,112.377 782.115,106.044 792.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.914
    },
    fill: "#1d4e7d",
    d: "M 545.5,104.5 C 549.846,104.334 554.179,104.501 558.5,105C 563.333,111.833 568.167,118.667 573,125.5C 577.107,118.396 581.607,111.562 586.5,105C 590.871,104.172 595.205,104.339 599.5,105.5C 592.833,114.833 586.167,124.167 579.5,133.5C 586.623,143.58 593.623,153.746 600.5,164C 595.833,164.667 591.167,164.667 586.5,164C 581.542,156.585 576.709,149.085 572,141.5C 567.291,149.085 562.458,156.585 557.5,164C 553.129,164.828 548.795,164.661 544.5,163.5C 551.306,153.528 558.306,143.694 565.5,134C 558.195,124.541 551.528,114.708 545.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.968
    },
    fill: "#0a9eca",
    d: "M 136.5,106.5 C 146.425,114.252 155.925,122.586 165,131.5C 165.333,131.167 165.667,130.833 166,130.5C 168.4,132.729 170.567,135.063 172.5,137.5C 172.5,138.833 172.5,140.167 172.5,141.5C 160.5,130.5 148.5,119.5 136.5,108.5C 136.5,107.833 136.5,107.167 136.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#0e7eac",
    d: "M 68.5,107.5 C 80.1667,118.833 91.8333,130.167 103.5,141.5C 103.5,144.833 103.5,148.167 103.5,151.5C 91.8333,140.167 80.1667,128.833 68.5,117.5C 68.5,114.167 68.5,110.833 68.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.963
    },
    fill: "#079bc8",
    d: "M 136.5,108.5 C 148.5,119.5 160.5,130.5 172.5,141.5C 172.5,143.167 172.5,144.833 172.5,146.5C 160.5,134.833 148.5,123.167 136.5,111.5C 136.5,110.5 136.5,109.5 136.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#47caea",
    d: "M 205.5,102.5 C 206.033,105.122 207.033,107.622 208.5,110C 223.13,122.295 237.464,134.962 251.5,148C 253.078,149.094 254.745,149.928 256.5,150.5C 255.974,152.23 254.974,153.564 253.5,154.5C 237.375,139.907 221.375,125.907 205.5,112.5C 205.5,109.167 205.5,105.833 205.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#166191",
    d: "M -0.5,111.5 C 11.1667,122.833 22.8333,134.167 34.5,145.5C 34.5,148.5 34.5,151.5 34.5,154.5C 22.8333,143.167 11.1667,131.833 -0.5,120.5C -0.5,117.5 -0.5,114.5 -0.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.965
    },
    fill: "#0897c4",
    d: "M 136.5,111.5 C 148.5,123.167 160.5,134.833 172.5,146.5C 172.5,150.5 172.5,154.5 172.5,158.5C 160.5,146.833 148.5,135.167 136.5,123.5C 136.5,119.5 136.5,115.5 136.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#3ac3e5",
    d: "M 205.5,115.5 C 209.87,121.379 214.87,126.879 220.5,132C 230.725,141.066 241.059,149.899 251.5,158.5C 250.89,160.434 249.89,162.101 248.5,163.5C 239.021,154.859 229.354,146.359 219.5,138C 214.202,133.212 209.535,128.045 205.5,122.5C 205.5,120.167 205.5,117.833 205.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#0f7ba9",
    d: "M 68.5,117.5 C 80.1667,128.833 91.8333,140.167 103.5,151.5C 103.5,153.833 103.5,156.167 103.5,158.5C 91.8333,147.167 80.1667,135.833 68.5,124.5C 68.5,122.167 68.5,119.833 68.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#41c8e9",
    d: "M 205.5,112.5 C 221.375,125.907 237.375,139.907 253.5,154.5C 253.34,156.153 252.674,157.486 251.5,158.5C 241.059,149.899 230.725,141.066 220.5,132C 214.87,126.879 209.87,121.379 205.5,115.5C 205.5,114.5 205.5,113.5 205.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#175e8e",
    d: "M -0.5,120.5 C 11.1667,131.833 22.8333,143.167 34.5,154.5C 34.5,156.5 34.5,158.5 34.5,160.5C 22.8333,149.167 11.1667,137.833 -0.5,126.5C -0.5,124.5 -0.5,122.5 -0.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#34bfe2",
    d: "M 205.5,122.5 C 209.535,128.045 214.202,133.212 219.5,138C 229.354,146.359 239.021,154.859 248.5,163.5C 248.443,164.609 248.11,165.609 247.5,166.5C 232.875,154.875 218.875,142.542 205.5,129.5C 205.5,127.167 205.5,124.833 205.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.965
    },
    fill: "#0994c2",
    d: "M 136.5,123.5 C 148.5,135.167 160.5,146.833 172.5,158.5C 172.5,159.833 172.5,161.167 172.5,162.5C 160.5,150.833 148.5,139.167 136.5,127.5C 136.5,126.167 136.5,124.833 136.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1078a6",
    d: "M 68.5,124.5 C 80.1667,135.833 91.8333,147.167 103.5,158.5C 103.5,161.167 103.5,163.833 103.5,166.5C 91.8333,155.167 80.1667,143.833 68.5,132.5C 68.5,129.833 68.5,127.167 68.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#175b8b",
    d: "M -0.5,126.5 C 11.1667,137.833 22.8333,149.167 34.5,160.5C 34.5,163.833 34.5,167.167 34.5,170.5C 22.8333,159.167 11.1667,147.833 -0.5,136.5C -0.5,133.167 -0.5,129.833 -0.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.914
    },
    fill: "#00b7e3",
    d: "M 309.5,216.5 C 307.975,213.921 306.641,211.254 305.5,208.5C 304.871,205.603 303.871,202.936 302.5,200.5C 302.065,197.843 301.065,195.509 299.5,193.5C 295.595,184.021 290.928,175.021 285.5,166.5C 293.07,153.03 300.903,139.696 309,126.5C 309.5,156.498 309.667,186.498 309.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#0991bf",
    d: "M 136.5,127.5 C 148.5,139.167 160.5,150.833 172.5,162.5C 171.416,165.004 170.083,167.337 168.5,169.5C 157.833,159.167 147.167,148.833 136.5,138.5C 136.5,134.833 136.5,131.167 136.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2ebce0",
    d: "M 205.5,129.5 C 218.875,142.542 232.875,154.875 247.5,166.5C 247.167,167.5 246.5,168.167 245.5,168.5C 244.883,168.611 244.383,168.944 244,169.5C 231,158.664 218.167,147.664 205.5,136.5C 205.5,134.167 205.5,131.833 205.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1175a3",
    d: "M 68.5,132.5 C 80.1667,143.833 91.8333,155.167 103.5,166.5C 103.5,168.833 103.5,171.167 103.5,173.5C 91.8333,162.167 80.1667,150.833 68.5,139.5C 68.5,137.167 68.5,134.833 68.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#28b7dd",
    d: "M 205.5,136.5 C 218.167,147.664 231,158.664 244,169.5C 244.383,168.944 244.883,168.611 245.5,168.5C 244.25,171.006 243.584,173.673 243.5,176.5C 231.434,164.097 218.767,152.43 205.5,141.5C 205.5,139.833 205.5,138.167 205.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#185888",
    d: "M -0.5,136.5 C 11.1667,147.833 22.8333,159.167 34.5,170.5C 34.5,172.167 34.5,173.833 34.5,175.5C 22.8333,164.167 11.1667,152.833 -0.5,141.5C -0.5,139.833 -0.5,138.167 -0.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#0a8ebc",
    d: "M 136.5,138.5 C 147.167,148.833 157.833,159.167 168.5,169.5C 168.068,170.71 167.401,171.71 166.5,172.5C 156.833,162.167 146.833,152.167 136.5,142.5C 136.5,141.167 136.5,139.833 136.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1172a0",
    d: "M 68.5,139.5 C 80.1667,150.833 91.8333,162.167 103.5,173.5C 103.5,176.167 103.5,178.833 103.5,181.5C 91.8333,170.167 80.1667,158.833 68.5,147.5C 68.5,144.833 68.5,142.167 68.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#195585",
    d: "M -0.5,141.5 C 11.1667,152.833 22.8333,164.167 34.5,175.5C 34.5,178.833 34.5,182.167 34.5,185.5C 22.8333,174.167 11.1667,162.833 -0.5,151.5C -0.5,148.167 -0.5,144.833 -0.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "#22b3da",
    d: "M 205.5,141.5 C 218.767,152.43 231.434,164.097 243.5,176.5C 243.5,177.5 243.5,178.5 243.5,179.5C 230.53,169.326 217.863,158.659 205.5,147.5C 205.5,145.5 205.5,143.5 205.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.97
    },
    fill: "#0b8bb9",
    d: "M 136.5,142.5 C 146.833,152.167 156.833,162.167 166.5,172.5C 165.921,175.331 164.588,177.664 162.5,179.5C 154.167,170.5 145.5,161.833 136.5,153.5C 136.5,149.833 136.5,146.167 136.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#1db0d8",
    d: "M 205.5,147.5 C 217.863,158.659 230.53,169.326 243.5,179.5C 243.5,181.167 243.5,182.833 243.5,184.5C 242.883,184.611 242.383,184.944 242,185.5C 230.268,173.265 218.101,161.599 205.5,150.5C 205.5,149.5 205.5,148.5 205.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#126e9d",
    d: "M 68.5,147.5 C 80.1667,158.833 91.8333,170.167 103.5,181.5C 103.5,184.167 103.5,186.833 103.5,189.5C 91.8333,178.167 80.1667,166.833 68.5,155.5C 68.5,152.833 68.5,150.167 68.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#19add5",
    d: "M 205.5,150.5 C 218.101,161.599 230.268,173.265 242,185.5C 242.383,184.944 242.883,184.611 243.5,184.5C 243.5,186.5 243.5,188.5 243.5,190.5C 231.188,178.19 218.522,166.19 205.5,154.5C 205.5,153.167 205.5,151.833 205.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1a5282",
    d: "M -0.5,151.5 C 11.1667,162.833 22.8333,174.167 34.5,185.5C 34.5,187.167 34.5,188.833 34.5,190.5C 22.8333,179.167 11.1667,167.833 -0.5,156.5C -0.5,154.833 -0.5,153.167 -0.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#0c88b6",
    d: "M 136.5,153.5 C 145.5,161.833 154.167,170.5 162.5,179.5C 162.34,181.153 161.674,182.486 160.5,183.5C 152.167,174.5 143.5,165.833 134.5,157.5C 135.167,156.167 135.833,154.833 136.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#15a9d3",
    d: "M 205.5,154.5 C 218.522,166.19 231.188,178.19 243.5,190.5C 243.5,191.5 243.5,192.5 243.5,193.5C 230.833,181.833 218.167,170.167 205.5,158.5C 205.5,157.167 205.5,155.833 205.5,154.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#136b9a",
    d: "M 68.5,155.5 C 80.1667,166.833 91.8333,178.167 103.5,189.5C 103.5,191.833 103.5,194.167 103.5,196.5C 91.8333,185.167 80.1667,173.833 68.5,162.5C 68.5,160.167 68.5,157.833 68.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1b4e7e",
    d: "M -0.5,156.5 C 11.1667,167.833 22.8333,179.167 34.5,190.5C 34.5,194.833 34.5,199.167 34.5,203.5C 22.8333,192.167 11.1667,180.833 -0.5,169.5C -0.5,165.167 -0.5,160.833 -0.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#0d85b3",
    d: "M 134.5,157.5 C 143.5,165.833 152.167,174.5 160.5,183.5C 159.737,185.368 158.737,187.035 157.5,188.5C 148.833,180.167 140.167,171.833 131.5,163.5C 131.992,161.181 132.992,159.181 134.5,157.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#0fa5d0",
    d: "M 205.5,158.5 C 218.167,170.167 230.833,181.833 243.5,193.5C 243.5,195.833 243.5,198.167 243.5,200.5C 231.203,189.372 219.036,178.039 207,166.5C 206.617,167.056 206.117,167.389 205.5,167.5C 205.5,164.5 205.5,161.5 205.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#146897",
    d: "M 68.5,162.5 C 80.1667,173.833 91.8333,185.167 103.5,196.5C 103.5,199.833 103.5,203.167 103.5,206.5C 91.8333,195.167 80.1667,183.833 68.5,172.5C 68.5,169.167 68.5,165.833 68.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#0d81af",
    d: "M 131.5,163.5 C 140.167,171.833 148.833,180.167 157.5,188.5C 156.737,190.368 155.737,192.035 154.5,193.5C 146.167,184.5 137.5,175.833 128.5,167.5C 129.026,165.77 130.026,164.436 131.5,163.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#079fcb",
    d: "M 243.5,200.5 C 243.5,204.167 243.5,207.833 243.5,211.5C 230.5,198.833 217.5,186.167 204.5,173.5C 205.341,171.621 205.675,169.621 205.5,167.5C 206.117,167.389 206.617,167.056 207,166.5C 219.036,178.039 231.203,189.372 243.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#0e7eac",
    d: "M 128.5,167.5 C 137.5,175.833 146.167,184.5 154.5,193.5C 153.529,195.483 152.529,197.483 151.5,199.5C 142.5,191.167 133.833,182.5 125.5,173.5C 126.471,171.517 127.471,169.517 128.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1c4b7b",
    d: "M -0.5,169.5 C 11.1667,180.833 22.8333,192.167 34.5,203.5C 34.5,204.833 34.5,206.167 34.5,207.5C 22.8333,196.167 11.1667,184.833 -0.5,173.5C -0.5,172.167 -0.5,170.833 -0.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#156594",
    d: "M 68.5,172.5 C 80.1667,183.833 91.8333,195.167 103.5,206.5C 103.131,208.993 103.797,209.66 105.5,208.5C 113.833,217.167 122.167,225.833 130.5,234.5C 130.107,236.284 129.441,237.95 128.5,239.5C 108.5,219.833 88.5,200.167 68.5,180.5C 68.5,177.833 68.5,175.167 68.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1c4878",
    d: "M -0.5,173.5 C 11.1667,184.833 22.8333,196.167 34.5,207.5C 34.5,211.167 34.5,214.833 34.5,218.5C 22.8333,207.167 11.1667,195.833 -0.5,184.5C -0.5,180.833 -0.5,177.167 -0.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.966
    },
    fill: "#0f7ba9",
    d: "M 125.5,173.5 C 133.833,182.5 142.5,191.167 151.5,199.5C 150.974,201.23 149.974,202.564 148.5,203.5C 139.833,195.167 131.167,186.833 122.5,178.5C 123.11,176.566 124.11,174.899 125.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.981
    },
    fill: "#079bc8",
    d: "M 204.5,173.5 C 217.5,186.167 230.5,198.833 243.5,211.5C 243.5,213.167 243.5,214.833 243.5,216.5C 229.833,203.5 216.5,190.167 203.5,176.5C 203.557,175.391 203.89,174.391 204.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#48cbeb",
    d: "M 285.5,166.5 C 290.928,175.021 295.595,184.021 299.5,193.5C 299.565,193.938 299.399,194.272 299,194.5C 293,189.167 287,183.833 281,178.5C 280.517,177.552 280.351,176.552 280.5,175.5C 281.901,172.366 283.568,169.366 285.5,166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#0897c4",
    d: "M 203.5,176.5 C 216.5,190.167 229.833,203.5 243.5,216.5C 243.5,220.833 243.5,225.167 243.5,229.5C 228.167,214.833 213.167,199.833 198.5,184.5C 199.68,181.46 201.347,178.794 203.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#40c9e9",
    d: "M 280.5,175.5 C 280.351,176.552 280.517,177.552 281,178.5C 287,183.833 293,189.167 299,194.5C 299.399,194.272 299.565,193.938 299.5,193.5C 301.065,195.509 302.065,197.843 302.5,200.5C 302.631,201.239 302.464,201.906 302,202.5C 294.728,195.219 286.894,188.719 278.5,183C 277.748,182.329 277.414,181.496 277.5,180.5C 278.263,178.632 279.263,176.965 280.5,175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#1078a6",
    d: "M 122.5,178.5 C 131.167,186.833 139.833,195.167 148.5,203.5C 148.25,205.674 147.25,207.341 145.5,208.5C 136.833,200.167 128.167,191.833 119.5,183.5C 120.263,181.632 121.263,179.965 122.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#166191",
    d: "M 68.5,180.5 C 88.5,200.167 108.5,219.833 128.5,239.5C 127.154,241.537 125.82,243.537 124.5,245.5C 106.167,226.5 87.5,207.833 68.5,189.5C 68.5,186.5 68.5,183.5 68.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3ac6e8",
    d: "M 277.5,180.5 C 277.414,181.496 277.748,182.329 278.5,183C 286.894,188.719 294.728,195.219 302,202.5C 302.464,201.906 302.631,201.239 302.5,200.5C 303.871,202.936 304.871,205.603 305.5,208.5C 305.483,210.028 304.816,210.528 303.5,210C 294.002,201.937 285.002,193.437 276.5,184.5C 276.232,182.901 276.566,181.568 277.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#1175a3",
    d: "M 119.5,183.5 C 128.167,191.833 136.833,200.167 145.5,208.5C 145.107,210.284 144.441,211.95 143.5,213.5C 134.5,205.167 125.833,196.5 117.5,187.5C 117.66,185.847 118.326,184.514 119.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1d4575",
    d: "M -0.5,184.5 C 11.1667,195.833 22.8333,207.167 34.5,218.5C 34.5,219.833 34.5,221.167 34.5,222.5C 22.8333,211.167 11.1667,199.833 -0.5,188.5C -0.5,187.167 -0.5,185.833 -0.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#0994c2",
    d: "M 198.5,184.5 C 213.167,199.833 228.167,214.833 243.5,229.5C 243.5,230.5 243.5,231.5 243.5,232.5C 227.833,217.5 212.5,202.167 197.5,186.5C 197.328,185.508 197.662,184.842 198.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#0991bf",
    d: "M 197.5,186.5 C 212.5,202.167 227.833,217.5 243.5,232.5C 243.5,236.5 243.5,240.5 243.5,244.5C 226.5,227.833 209.5,211.167 192.5,194.5C 194.181,191.797 195.847,189.131 197.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#1172a0",
    d: "M 117.5,187.5 C 125.833,196.5 134.5,205.167 143.5,213.5C 142.248,215.001 141.248,216.668 140.5,218.5C 131.5,210.167 122.833,201.5 114.5,192.5C 115.11,190.566 116.11,188.899 117.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#34c3e6",
    d: "M 276.5,184.5 C 285.002,193.437 294.002,201.937 303.5,210C 304.816,210.528 305.483,210.028 305.5,208.5C 306.641,211.254 307.975,213.921 309.5,216.5C 309.5,217.5 309.5,218.5 309.5,219.5C 309.167,219.5 308.833,219.5 308.5,219.5C 298.373,211.21 288.373,202.71 278.5,194C 277.891,192.052 277.224,190.218 276.5,188.5C 276.5,187.167 276.5,185.833 276.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1e4172",
    d: "M -0.5,188.5 C 11.1667,199.833 22.8333,211.167 34.5,222.5C 34.5,226.833 34.5,231.167 34.5,235.5C 22.8333,224.167 11.1667,212.833 -0.5,201.5C -0.5,197.167 -0.5,192.833 -0.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#175e8e",
    d: "M 68.5,189.5 C 87.5,207.833 106.167,226.5 124.5,245.5C 124.068,246.71 123.401,247.71 122.5,248.5C 104.5,230.833 86.5,213.167 68.5,195.5C 68.5,193.5 68.5,191.5 68.5,189.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#2ebee3",
    d: "M 276.5,188.5 C 277.224,190.218 277.891,192.052 278.5,194C 288.373,202.71 298.373,211.21 308.5,219.5C 308.799,221.604 308.466,223.604 307.5,225.5C 298.648,217.48 289.648,209.647 280.5,202C 278.372,200.208 277.039,198.042 276.5,195.5C 276.5,193.167 276.5,190.833 276.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#126e9d",
    d: "M 114.5,192.5 C 122.833,201.5 131.5,210.167 140.5,218.5C 139.752,220.332 138.752,221.999 137.5,223.5C 128.5,215.167 119.833,206.5 111.5,197.5C 112.11,195.566 113.11,193.899 114.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#0a8ebc",
    d: "M 192.5,194.5 C 209.5,211.167 226.5,227.833 243.5,244.5C 243.5,245.5 243.5,246.5 243.5,247.5C 226.167,230.5 208.833,213.5 191.5,196.5C 191.833,195.833 192.167,195.167 192.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#175b8b",
    d: "M 68.5,195.5 C 86.5,213.167 104.5,230.833 122.5,248.5C 121.921,251.331 120.588,253.664 118.5,255.5C 102.167,238.5 85.5,221.833 68.5,205.5C 68.5,202.167 68.5,198.833 68.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#0b8bb9",
    d: "M 191.5,196.5 C 208.833,213.5 226.167,230.5 243.5,247.5C 243.5,251.5 243.5,255.5 243.5,259.5C 224.5,241.167 205.833,222.5 187.5,203.5C 188.596,200.968 189.929,198.635 191.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#136c9b",
    d: "M 111.5,197.5 C 119.833,206.5 128.5,215.167 137.5,223.5C 136.974,225.23 135.974,226.564 134.5,227.5C 125.833,219.167 117.167,210.833 108.5,202.5C 109.263,200.632 110.263,198.965 111.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#28bae0",
    d: "M 276.5,195.5 C 277.039,198.042 278.372,200.208 280.5,202C 289.648,209.647 298.648,217.48 307.5,225.5C 308.466,223.604 308.799,221.604 308.5,219.5C 308.833,219.5 309.167,219.5 309.5,219.5C 309.5,223.167 309.5,226.833 309.5,230.5C 308.883,230.611 308.383,230.944 308,231.5C 298.549,221.873 288.382,213.207 277.5,205.5C 277.167,205.5 276.833,205.5 276.5,205.5C 276.5,202.167 276.5,198.833 276.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#146897",
    d: "M 108.5,202.5 C 117.167,210.833 125.833,219.167 134.5,227.5C 133.921,230.331 132.588,232.664 130.5,234.5C 122.167,225.833 113.833,217.167 105.5,208.5C 105.992,206.181 106.992,204.181 108.5,202.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1f3e6f",
    d: "M -0.5,201.5 C 11.1667,212.833 22.8333,224.167 34.5,235.5C 34.5,237.167 34.5,238.833 34.5,240.5C 22.8333,229.167 11.1667,217.833 -0.5,206.5C -0.5,204.833 -0.5,203.167 -0.5,201.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.983
    },
    fill: "#0c88b6",
    d: "M 187.5,203.5 C 205.833,222.5 224.5,241.167 243.5,259.5C 243.5,261.5 243.5,263.5 243.5,265.5C 223.833,246.5 204.5,227.167 185.5,207.5C 185.66,205.847 186.326,204.514 187.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#22b7de",
    d: "M 277.5,205.5 C 288.382,213.207 298.549,221.873 308,231.5C 308.383,230.944 308.883,230.611 309.5,230.5C 309.5,232.833 309.5,235.167 309.5,237.5C 299.169,228.003 288.669,218.67 278,209.5C 277.51,208.207 277.343,206.873 277.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#203b6c",
    d: "M -0.5,206.5 C 11.1667,217.833 22.8333,229.167 34.5,240.5C 34.5,243.833 34.5,247.167 34.5,250.5C 22.8333,239.167 11.1667,227.833 -0.5,216.5C -0.5,213.167 -0.5,209.833 -0.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#185888",
    d: "M 68.5,205.5 C 85.5,221.833 102.167,238.5 118.5,255.5C 118.573,257.027 117.906,258.027 116.5,258.5C 100.833,242.167 84.8333,226.167 68.5,210.5C 68.5,208.833 68.5,207.167 68.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#0d85b3",
    d: "M 185.5,207.5 C 204.5,227.167 223.833,246.5 243.5,265.5C 243.5,268.5 243.5,271.5 243.5,274.5C 231.833,263.167 220.167,251.833 208.5,240.5C 208.672,239.508 208.338,238.842 207.5,238.5C 198.833,230.167 190.167,221.833 181.5,213.5C 182.475,211.205 183.808,209.205 185.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.948
    },
    fill: "#1db3db",
    d: "M 276.5,205.5 C 276.833,205.5 277.167,205.5 277.5,205.5C 277.343,206.873 277.51,208.207 278,209.5C 288.669,218.67 299.169,228.003 309.5,237.5C 309.5,239.833 309.5,242.167 309.5,244.5C 298.86,233.194 287.86,222.194 276.5,211.5C 276.5,209.5 276.5,207.5 276.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#195585",
    d: "M 68.5,210.5 C 84.8333,226.167 100.833,242.167 116.5,258.5C 116.008,260.819 115.008,262.819 113.5,264.5C 98.5,249.833 83.5,235.167 68.5,220.5C 68.5,217.167 68.5,213.833 68.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.966
    },
    fill: "#19b0d9",
    d: "M 276.5,211.5 C 287.86,222.194 298.86,233.194 309.5,244.5C 309.5,245.5 309.5,246.5 309.5,247.5C 298.318,236.646 287.318,225.979 276.5,215.5C 276.5,214.167 276.5,212.833 276.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#0d81af",
    d: "M 181.5,213.5 C 190.167,221.833 198.833,230.167 207.5,238.5C 206.89,240.434 205.89,242.101 204.5,243.5C 196.167,234.833 187.833,226.167 179.5,217.5C 179.733,215.938 180.4,214.605 181.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.942
    },
    fill: "#14acd6",
    d: "M 276.5,215.5 C 287.318,225.979 298.318,236.646 309.5,247.5C 309.5,249.5 309.5,251.5 309.5,253.5C 300.005,244.838 291.005,235.672 282.5,226C 280.113,225.436 278.113,224.27 276.5,222.5C 276.5,220.167 276.5,217.833 276.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#0e7eac",
    d: "M 179.5,217.5 C 187.833,226.167 196.167,234.833 204.5,243.5C 204.025,245.784 203.025,247.784 201.5,249.5C 192.833,241.167 184.167,232.833 175.5,224.5C 176.584,221.996 177.917,219.663 179.5,217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.97
    },
    fill: "#213869",
    d: "M -0.5,216.5 C 11.1667,227.833 22.8333,239.167 34.5,250.5C 34.6666,263.171 34.4999,275.838 34,288.5C 22.3907,281.948 10.8907,275.281 -0.5,268.5C -0.5,251.167 -0.5,233.833 -0.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#1a5282",
    d: "M 68.5,220.5 C 83.5,235.167 98.5,249.833 113.5,264.5C 113.068,265.71 112.401,266.71 111.5,267.5C 97.1667,253.5 82.8333,239.5 68.5,225.5C 68.5,223.833 68.5,222.167 68.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.958
    },
    fill: "#0fa8d3",
    d: "M 276.5,222.5 C 278.113,224.27 280.113,225.436 282.5,226C 291.005,235.672 300.005,244.838 309.5,253.5C 309.5,254.833 309.5,256.167 309.5,257.5C 299.49,247.324 288.99,237.657 278,228.5C 277.617,229.056 277.117,229.389 276.5,229.5C 276.5,227.167 276.5,224.833 276.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#0f7ba9",
    d: "M 175.5,224.5 C 184.167,232.833 192.833,241.167 201.5,249.5C 200.833,250.833 200.167,252.167 199.5,253.5C 190.5,245.167 181.833,236.5 173.5,227.5C 173.932,226.29 174.599,225.29 175.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#1b4e7f",
    d: "M 68.5,225.5 C 82.8333,239.5 97.1667,253.5 111.5,267.5C 110.226,270.76 108.56,273.76 106.5,276.5C 94.1667,263.5 81.5,250.833 68.5,238.5C 68.5,234.167 68.5,229.833 68.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.967
    },
    fill: "#1078a6",
    d: "M 173.5,227.5 C 181.833,236.5 190.5,245.167 199.5,253.5C 198.154,255.537 196.82,257.537 195.5,259.5C 187.167,250.833 178.833,242.167 170.5,233.5C 170.992,231.181 171.992,229.181 173.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.967
    },
    fill: "#09a4d0",
    d: "M 309.5,257.5 C 309.5,259.167 309.5,260.833 309.5,262.5C 298.607,252.248 287.607,242.248 276.5,232.5C 276.5,231.5 276.5,230.5 276.5,229.5C 277.117,229.389 277.617,229.056 278,228.5C 288.99,237.657 299.49,247.324 309.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.959
    },
    fill: "#05a0cc",
    d: "M 276.5,232.5 C 287.607,242.248 298.607,252.248 309.5,262.5C 310.428,266.483 309.095,269.15 305.5,270.5C 296.167,260.5 286.5,250.833 276.5,241.5C 276.5,238.5 276.5,235.5 276.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#1175a3",
    d: "M 170.5,233.5 C 178.833,242.167 187.167,250.833 195.5,259.5C 195.068,260.71 194.401,261.71 193.5,262.5C 184.833,254.167 176.167,245.833 167.5,237.5C 168.026,235.77 169.026,234.436 170.5,233.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#1172a0",
    d: "M 167.5,237.5 C 176.167,245.833 184.833,254.167 193.5,262.5C 193.025,264.784 192.025,266.784 190.5,268.5C 181.833,260.167 173.167,251.833 164.5,243.5C 165.471,241.517 166.471,239.517 167.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#1c4b7b",
    d: "M 68.5,238.5 C 81.5,250.833 94.1667,263.5 106.5,276.5C 106.5,277.5 106.5,278.5 106.5,279.5C 93.8333,267.167 81.1667,254.833 68.5,242.5C 68.5,241.167 68.5,239.833 68.5,238.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#0d81af",
    d: "M 208.5,240.5 C 220.167,251.833 231.833,263.167 243.5,274.5C 243.5,276.833 243.5,279.167 243.5,281.5C 231.833,270.167 220.167,258.833 208.5,247.5C 208.5,245.167 208.5,242.833 208.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#1c4878",
    d: "M 68.5,242.5 C 81.1667,254.833 93.8333,267.167 106.5,279.5C 106.5,283.167 106.5,286.833 106.5,290.5C 93.8333,278.167 81.1667,265.833 68.5,253.5C 68.5,249.833 68.5,246.167 68.5,242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.966
    },
    fill: "#126e9d",
    d: "M 164.5,243.5 C 173.167,251.833 181.833,260.167 190.5,268.5C 189.737,270.368 188.737,272.035 187.5,273.5C 179.167,264.5 170.5,255.833 161.5,247.5C 162.512,246.128 163.512,244.795 164.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.92
    },
    fill: "#00a0cd",
    d: "M 399.5,244.5 C 405.167,244.5 410.833,244.5 416.5,244.5C 416.5,245.5 416.5,246.5 416.5,247.5C 414.167,247.5 411.833,247.5 409.5,247.5C 409.5,253.833 409.5,260.167 409.5,266.5C 408.5,266.5 407.5,266.5 406.5,266.5C 406.5,260.167 406.5,253.833 406.5,247.5C 404.167,247.5 401.833,247.5 399.5,247.5C 399.5,246.5 399.5,245.5 399.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00a0cd",
    d: "M 424.5,244.5 C 425.5,244.5 426.5,244.5 427.5,244.5C 427.5,251.833 427.5,259.167 427.5,266.5C 426.5,266.5 425.5,266.5 424.5,266.5C 424.5,259.167 424.5,251.833 424.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.769
    },
    fill: "#00a0cd",
    d: "M 444.5,244.5 C 448.514,244.334 452.514,244.501 456.5,245C 455.809,246.067 455.309,247.234 455,248.5C 447.662,245.831 443.162,248.331 441.5,256C 443.006,262.262 447.006,264.762 453.5,263.5C 453.5,261.5 453.5,259.5 453.5,257.5C 451.833,257.5 450.167,257.5 448.5,257.5C 448.5,256.5 448.5,255.5 448.5,254.5C 451.167,254.5 453.833,254.5 456.5,254.5C 456.5,258.5 456.5,262.5 456.5,266.5C 443.018,269.178 437.184,263.844 439,250.5C 440.36,247.977 442.193,245.977 444.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.931
    },
    fill: "#00a0cd",
    d: "M 467.5,244.5 C 468.5,244.5 469.5,244.5 470.5,244.5C 470.5,250.833 470.5,257.167 470.5,263.5C 473.833,263.5 477.167,263.5 480.5,263.5C 480.5,264.5 480.5,265.5 480.5,266.5C 476.167,266.5 471.833,266.5 467.5,266.5C 467.5,259.167 467.5,251.833 467.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00a0cd",
    d: "M 490.5,244.5 C 491.5,244.5 492.5,244.5 493.5,244.5C 493.5,251.833 493.5,259.167 493.5,266.5C 492.5,266.5 491.5,266.5 490.5,266.5C 490.5,259.167 490.5,251.833 490.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.84
    },
    fill: "#00a0cd",
    d: "M 504.5,244.5 C 506.722,244.178 508.556,244.845 510,246.5C 512.416,251.001 515.083,255.334 518,259.5C 518.499,254.511 518.666,249.511 518.5,244.5C 519.5,244.5 520.5,244.5 521.5,244.5C 521.5,251.833 521.5,259.167 521.5,266.5C 520.022,266.762 518.689,266.429 517.5,265.5C 514.136,260.634 510.969,255.634 508,250.5C 507.501,255.823 507.334,261.156 507.5,266.5C 506.5,266.5 505.5,266.5 504.5,266.5C 504.5,259.167 504.5,251.833 504.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.872
    },
    fill: "#00a0cd",
    d: "M 533.5,244.5 C 537.5,244.5 541.5,244.5 545.5,244.5C 545.5,245.5 545.5,246.5 545.5,247.5C 542.5,247.5 539.5,247.5 536.5,247.5C 536.5,249.5 536.5,251.5 536.5,253.5C 539.5,253.5 542.5,253.5 545.5,253.5C 545.5,254.5 545.5,255.5 545.5,256.5C 542.5,256.5 539.5,256.5 536.5,256.5C 536.5,258.833 536.5,261.167 536.5,263.5C 539.833,263.5 543.167,263.5 546.5,263.5C 546.5,264.5 546.5,265.5 546.5,266.5C 542.167,266.5 537.833,266.5 533.5,266.5C 533.5,259.167 533.5,251.833 533.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.964
    },
    fill: "#00a0cd",
    d: "M 577.5,244.5 C 578.5,244.5 579.5,244.5 580.5,244.5C 580.5,247.5 580.5,250.5 580.5,253.5C 584.167,253.5 587.833,253.5 591.5,253.5C 591.5,250.5 591.5,247.5 591.5,244.5C 592.5,244.5 593.5,244.5 594.5,244.5C 594.5,251.833 594.5,259.167 594.5,266.5C 593.5,266.5 592.5,266.5 591.5,266.5C 591.5,263.167 591.5,259.833 591.5,256.5C 587.833,256.5 584.167,256.5 580.5,256.5C 580.5,259.833 580.5,263.167 580.5,266.5C 579.5,266.5 578.5,266.5 577.5,266.5C 577.5,259.167 577.5,251.833 577.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.872
    },
    fill: "#00a0cd",
    d: "M 619.5,244.5 C 623.5,244.5 627.5,244.5 631.5,244.5C 631.5,245.5 631.5,246.5 631.5,247.5C 628.5,247.5 625.5,247.5 622.5,247.5C 622.5,249.5 622.5,251.5 622.5,253.5C 625.5,253.5 628.5,253.5 631.5,253.5C 631.5,254.5 631.5,255.5 631.5,256.5C 628.5,256.5 625.5,256.5 622.5,256.5C 622.5,258.833 622.5,261.167 622.5,263.5C 625.833,263.5 629.167,263.5 632.5,263.5C 632.5,264.5 632.5,265.5 632.5,266.5C 628.167,266.5 623.833,266.5 619.5,266.5C 619.5,259.167 619.5,251.833 619.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.837
    },
    fill: "#00a0cd",
    d: "M 656.5,244.5 C 660.182,244.335 663.848,244.501 667.5,245C 671.487,248.62 671.487,252.287 667.5,256C 669.506,258.841 670.839,262.008 671.5,265.5C 670.167,266.833 668.833,266.833 667.5,265.5C 666.877,262.833 665.877,260.333 664.5,258C 662.866,257.506 661.199,257.34 659.5,257.5C 659.5,260.5 659.5,263.5 659.5,266.5C 658.5,266.5 657.5,266.5 656.5,266.5C 656.5,259.167 656.5,251.833 656.5,244.5 Z M 659.5,247.5 C 662.908,246.828 665.575,247.828 667.5,250.5C 665.657,253.422 662.99,254.755 659.5,254.5C 659.5,252.167 659.5,249.833 659.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.872
    },
    fill: "#00a0cd",
    d: "M 695.5,244.5 C 699.5,244.5 703.5,244.5 707.5,244.5C 707.5,245.5 707.5,246.5 707.5,247.5C 704.5,247.5 701.5,247.5 698.5,247.5C 698.5,249.5 698.5,251.5 698.5,253.5C 701.5,253.5 704.5,253.5 707.5,253.5C 707.5,254.5 707.5,255.5 707.5,256.5C 704.5,256.5 701.5,256.5 698.5,256.5C 698.5,258.833 698.5,261.167 698.5,263.5C 701.833,263.5 705.167,263.5 708.5,263.5C 708.5,264.5 708.5,265.5 708.5,266.5C 704.167,266.5 699.833,266.5 695.5,266.5C 695.5,259.167 695.5,251.833 695.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#079cc9",
    d: "M 276.5,241.5 C 286.5,250.833 296.167,260.5 305.5,270.5C 303.784,272.025 301.784,273.025 299.5,273.5C 292.167,265.5 284.5,257.833 276.5,250.5C 276.5,247.5 276.5,244.5 276.5,241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#136b9a",
    d: "M 161.5,247.5 C 170.5,255.833 179.167,264.5 187.5,273.5C 186.737,275.368 185.737,277.035 184.5,278.5C 176.167,269.833 167.833,261.167 159.5,252.5C 159.893,250.716 160.559,249.05 161.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#0e7eac",
    d: "M 208.5,247.5 C 220.167,258.833 231.833,270.167 243.5,281.5C 243.5,284.833 243.5,288.167 243.5,291.5C 231.833,280.167 220.167,268.833 208.5,257.5C 208.5,254.167 208.5,250.833 208.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.944
    },
    fill: "#0898c5",
    d: "M 276.5,250.5 C 284.5,257.833 292.167,265.5 299.5,273.5C 297.664,275.588 295.331,276.921 292.5,277.5C 287.167,272.5 281.833,267.5 276.5,262.5C 276.5,258.5 276.5,254.5 276.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#146897",
    d: "M 159.5,252.5 C 167.833,261.167 176.167,269.833 184.5,278.5C 183.5,280.5 182.5,282.5 181.5,284.5C 172.833,276.167 164.167,267.833 155.5,259.5C 156.079,256.669 157.412,254.336 159.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#1d4575",
    d: "M 68.5,253.5 C 81.1667,265.833 93.8333,278.167 106.5,290.5C 106.5,291.833 106.5,293.167 106.5,294.5C 93.8333,282.167 81.1667,269.833 68.5,257.5C 68.5,256.167 68.5,254.833 68.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#1e4172",
    d: "M 68.5,257.5 C 81.1667,269.833 93.8333,282.167 106.5,294.5C 106.5,298.833 106.5,303.167 106.5,307.5C 93.8333,295.167 81.1667,282.833 68.5,270.5C 68.5,266.167 68.5,261.833 68.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#0f7ba9",
    d: "M 208.5,257.5 C 220.167,268.833 231.833,280.167 243.5,291.5C 243.5,293.5 243.5,295.5 243.5,297.5C 231.833,286.167 220.167,274.833 208.5,263.5C 208.5,261.5 208.5,259.5 208.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#156494",
    d: "M 155.5,259.5 C 164.167,267.833 172.833,276.167 181.5,284.5C 180.488,285.872 179.488,287.205 178.5,288.5C 169.833,280.167 161.167,271.833 152.5,263.5C 153.026,261.77 154.026,260.436 155.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#166191",
    d: "M 152.5,263.5 C 161.167,271.833 169.833,280.167 178.5,288.5C 178.025,290.784 177.025,292.784 175.5,294.5C 166.833,286.167 158.167,277.833 149.5,269.5C 149.975,267.216 150.975,265.216 152.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1078a6",
    d: "M 208.5,263.5 C 220.167,274.833 231.833,286.167 243.5,297.5C 243.81,300.713 243.477,303.713 242.5,306.5C 231.5,294.833 220.167,283.5 208.5,272.5C 208.5,269.5 208.5,266.5 208.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.89
    },
    fill: "#0992bf",
    d: "M 276.5,262.5 C 281.833,267.5 287.167,272.5 292.5,277.5C 287.657,281.337 282.323,284.337 276.5,286.5C 276.5,278.5 276.5,270.5 276.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#175e8e",
    d: "M 149.5,269.5 C 158.167,277.833 166.833,286.167 175.5,294.5C 174.699,296.042 174.366,297.708 174.5,299.5C 165.167,290.833 156.167,281.833 147.5,272.5C 147.932,271.29 148.599,270.29 149.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#1f3e6f",
    d: "M 68.5,270.5 C 81.1667,282.833 93.8333,295.167 106.5,307.5C 106.5,309.167 106.5,310.833 106.5,312.5C 93.8333,300.167 81.1667,287.833 68.5,275.5C 68.5,273.833 68.5,272.167 68.5,270.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#175b8b",
    d: "M 147.5,272.5 C 156.167,281.833 165.167,290.833 174.5,299.5C 174.5,302.833 174.5,306.167 174.5,309.5C 164.167,299.5 153.833,289.5 143.5,279.5C 144.596,276.968 145.929,274.635 147.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "#1175a3",
    d: "M 208.5,272.5 C 220.167,283.5 231.5,294.833 242.5,306.5C 242.027,307.906 241.027,308.573 239.5,308.5C 229.167,298.5 218.833,288.5 208.5,278.5C 208.5,276.5 208.5,274.5 208.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#203b6c",
    d: "M 68.5,275.5 C 81.1667,287.833 93.8333,300.167 106.5,312.5C 106.5,315.833 106.5,319.167 106.5,322.5C 93.8333,310.167 81.1667,297.833 68.5,285.5C 68.5,282.167 68.5,278.833 68.5,275.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1172a0",
    d: "M 208.5,278.5 C 218.833,288.5 229.167,298.5 239.5,308.5C 237.537,309.82 235.537,311.154 233.5,312.5C 225.5,303.833 217.167,295.5 208.5,287.5C 208.5,284.5 208.5,281.5 208.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#185888",
    d: "M 143.5,279.5 C 153.833,289.5 164.167,299.5 174.5,309.5C 174.5,311.167 174.5,312.833 174.5,314.5C 163.5,303.833 152.5,293.167 141.5,282.5C 141.932,281.29 142.599,280.29 143.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#195585",
    d: "M 141.5,282.5 C 152.5,293.167 163.5,303.833 174.5,314.5C 174.5,317.833 174.5,321.167 174.5,324.5C 162.833,313.167 151.167,301.833 139.5,290.5C 139.107,287.487 139.774,284.82 141.5,282.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.953
    },
    fill: "#213869",
    d: "M 68.5,285.5 C 81.1667,297.833 93.8333,310.167 106.5,322.5C 106.5,324.833 106.5,327.167 106.5,329.5C 93.6937,323.177 81.1937,316.177 69,308.5C 68.5003,300.841 68.3336,293.174 68.5,285.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#126f9e",
    d: "M 208.5,287.5 C 217.167,295.5 225.5,303.833 233.5,312.5C 232.167,313.167 230.833,313.833 229.5,314.5C 222.5,307.833 215.5,301.167 208.5,294.5C 208.5,292.167 208.5,289.833 208.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1a5282",
    d: "M 139.5,290.5 C 151.167,301.833 162.833,313.167 174.5,324.5C 174.5,326.167 174.5,327.833 174.5,329.5C 162.833,318.167 151.167,306.833 139.5,295.5C 139.5,293.833 139.5,292.167 139.5,290.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#136c9b",
    d: "M 208.5,294.5 C 215.5,301.167 222.5,307.833 229.5,314.5C 227.819,316.008 225.819,317.008 223.5,317.5C 218.833,312.167 213.833,307.167 208.5,302.5C 208.5,299.833 208.5,297.167 208.5,294.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1b4e7e",
    d: "M 139.5,295.5 C 151.167,306.833 162.833,318.167 174.5,329.5C 174.5,334.167 174.5,338.833 174.5,343.5C 162.833,332.167 151.167,320.833 139.5,309.5C 139.5,304.833 139.5,300.167 139.5,295.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#146897",
    d: "M 208.5,302.5 C 213.833,307.167 218.833,312.167 223.5,317.5C 221.882,319.316 219.882,320.649 217.5,321.5C 214.833,318.167 211.833,315.167 208.5,312.5C 208.5,309.167 208.5,305.833 208.5,302.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#1c4b7b",
    d: "M 139.5,309.5 C 151.167,320.833 162.833,332.167 174.5,343.5C 174.737,344.791 174.404,345.791 173.5,346.5C 162.167,335.5 150.833,324.5 139.5,313.5C 139.5,312.167 139.5,310.833 139.5,309.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.96
    },
    fill: "#156494",
    d: "M 208.5,312.5 C 211.833,315.167 214.833,318.167 217.5,321.5C 214.861,323.156 212.195,324.822 209.5,326.5C 208.507,321.88 208.173,317.214 208.5,312.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#1c4778",
    d: "M 139.5,313.5 C 150.833,324.5 162.167,335.5 173.5,346.5C 170.506,349 167.173,351 163.5,352.5C 155.833,344.167 147.833,336.167 139.5,328.5C 139.5,323.5 139.5,318.5 139.5,313.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.958
    },
    fill: "#1e4273",
    d: "M 139.5,328.5 C 147.833,336.167 155.833,344.167 163.5,352.5C 161.664,354.588 159.331,355.921 156.5,356.5C 150.833,351.167 145.167,345.833 139.5,340.5C 139.5,336.5 139.5,332.5 139.5,328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.948
    },
    fill: "#1f3e6f",
    d: "M 139.5,340.5 C 145.167,345.833 150.833,351.167 156.5,356.5C 156.5,356.833 156.5,357.167 156.5,357.5C 155.167,357.5 153.833,357.5 152.5,357.5C 148.239,355.091 144.073,352.424 140,349.5C 139.502,346.518 139.335,343.518 139.5,340.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexatech);
export default __webpack_public_path__ + "static/media/hexatech.6dc83f53b540ad76730648ae0f578af8.svg";
export { ForwardRef as ReactComponent };